<div class="container">
    <ng-container *ngIf="showCorners">
        <svg
            *ngFor="let corner of ['top-left', 'top-right', 'bottom-left', 'bottom-right']" 
            [ngClass]="'container__corner container__corner--' + corner" 
            width="33" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M30 3.017H9c-2-.166-6 .8-6 6v17.499" stroke="#fff" stroke-width="6" stroke-linecap="round"/>
        </svg>
    </ng-container>
    
    <ng-content></ng-content>
</div>